<template>
  <div
    class="chat-timeline"
    :class="{ 'my-timeline': speaker === 'my', 'other-timeline': speaker === 'other' }"
  >
    <div class="avatar-box" :class="speaker">
      <!-- アイコン -->
      <img :src="iconCreate(icon, isBot, isManager)" />
      <Tooltip message="編集">
        <button
          class="edit-btn button is-small"
          @click.prevent="openEditModal()"
          v-if="isDemo && isBot && isAuth && !isSwitch && isDemoEditScenario"
        >
          <span class="mdi mdi-square-edit-outline mdi-16px"></span>
        </button>
      </Tooltip>
    </div>
    <div
      class="message-box"
      :class="{ 'my-message-box': speaker === 'my', 'other-message-box': speaker === 'other' }"
    >
      <div v-if="parentComponent === 'DirectTalk' && speaker === 'my'" class="target-name">{{ name }}</div>
      <!-- メッセージ -->
      <MessageParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :logIndex="logIndex"
        :isDemo="isDemo"
        :isDemoEditScenario="isDemoEditScenario"
        :scenarioID="getBeforeNode"
        :isConfirm="isConfirm"
        :roboArguments="roboArguments"
        @updateMainMessage="updateMainMessage"
        v-if="
          isMessage(message) && isFiles(filename) && isSearch(message) && isPdfDownload(message)
        "
      />
      <!-- 選択肢 -->
      <SelectParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        :isDemoEditScenario="isDemoEditScenario"
        :scenarioID="getBeforeNode"
        :isConfirm="isConfirm"
        :roboArguments="roboArguments"
        :isSubmitUrl="isSubmitUrl"
        @updateMainMessage="updateMainMessage"
        @pushButton="pushButton"
        @pushButtonCard="pushButtonCard"
        v-if="
          !isButton(message) &&
          isCalendar(message) &&
          isImage(message) &&
          isInput(message) &&
          isFileUpload(message) &&
          isFiles(filename) &&
          isSearch(message) &&
          isPdfDownload(message)
        "
      />
      <!-- 応募 -->
      <CVParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :skInfo="skInfo"
        :isDemo="isDemo"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :companyData="companyData"
        :renkeiID="null"
        :parameter="parameter"
        :roboArguments="roboArguments"
        @subscribe="subscribe"
        @initScenario="initScenario"
        v-if="!isCVForm(message)"
      />
      <!-- 入力フォーム -->
      <InputParts
        :isInputAfter="isInputAfter"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :message="message"
        :speaker="speaker"
        :color="color"
        :isDemo="isDemo"
        :roboArguments="roboArguments"
        @inputSubmit="inputSubmit"
        :parameter="parameter"
        v-if="!isInput(message)"
      />
      <!-- 画像表示 -->
      <ImageParts :message="message" :speaker="speaker" v-if="!isImage(message)" />
      <!-- アップロードパーツ -->
      <UploadParts
        :speaker="speaker"
        :color="color"
        @sendfile="sendfile"
        :parameter="parameter"
        :isDemo="isDemo"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :sendedFlg="sendedFlg"
        v-if="!isFileUpload(message)"
      />
      <!-- ファイル表示パーツ -->
      <!--
        履歴書パーツでPDFダウンロード可にした場合、UploadedPartsとResumeDownloadPartsが同時に表示されてしまう
        区別するためにmessageの内容を判定する
      -->
      <UploadedParts
        :speaker="speaker"
        :color="color"
        :filename="filename"
        :files="files"
        v-if="!isFiles(filename) && isOutput(message) && message==='File送付'"
      />
      <!-- カレンダーパーツ -->
      <CalendarParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isErrorRecommendSchedule="isErrorRecommendSchedule"
        :isDemo="isDemo"
        :preserveSuggestedSchedulesList="preserveSuggestedSchedulesList"
        :displayPrevBtnFlg="displayPrevBtnFlg"
        :parameter="parameter"
        :makeCalendar="makeCalendar"
        :roboArguments="roboArguments"
        @submit="submit"
        @nextDay="nextDay"
        @prevDay="prevDay"
        @reload="reloadCalendar"
        @create-interview-history="createInterviewHistory"
        @returnCalendar="returnCalendar"
        v-if="!isCalendar(message)"
      />
      <!-- 履歴書 -->
      <ResumeParts
        :parameter="parameter"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :speaker="speaker"
        :isDemo="isDemo"
        :isPast="isPast"
        @send-resume="sendResume"
        v-if="!isResume(message)"
      />
      <!-- 履歴書ダウンロードパーツ -->
      <ResumeDownloadParts
        :speaker="speaker"
        :color="color"
        :filename="filename"
        :files="files"
        v-if="!isResumePdf(filename) && isResume(message) && parameter && parameter.enable_download"
      />
      <!-- チェックボックスパーツ -->
      <CheckBoxParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        :roboArguments="roboArguments"
        @checkboxSubmit="checkboxSubmit"
        v-if="!isCheckBox(message)"
      />
      <!-- 動画パーツ -->
      <MovieParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        v-if="!isMovie(message)"
      />
      <!-- プルダウン選択パーツ -->
      <PullDownParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        :roboArguments="roboArguments"
        @pulldownSubmit="pulldownSubmit"
        v-if="!isPullDown(message)"
      />
      <!-- カルーセルパーツ -->
      <CarouselParts
        :message="message"
        :speaker="speaker"
        :parameter="parameter"
        :isBot="isBot"
        @pushButton="pushButton"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isDemo="isDemo"
        :roboArguments="roboArguments"
        v-if="!isCarousel(message)"
      />
      <!-- ダウンロードパーツ -->
      <DownloadParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        @afterDownload="afterDownload"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        :roboArguments="roboArguments"
        v-if="!isFileDownload(message)"
      />
      <!-- 回答出力 -->
      <OutputParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        :files="files"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        v-if="!isOutput(message)"
      />
      <!-- 検索パーツ -->
      <SearchParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        :companyData="companyData"
        :skInfo="skInfo"
        @pushSelect="pushSelect"
        @subscribe="subscribe"
        @setRenkeiID="setRenkeiID"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        :renkeiID="renkeiID"
        :roboArguments="roboArguments"
        v-if="!isSearch(message)"
      />
      <!-- PDFダウンロード -->
      <PdfDownloadParts
        :message="message"
        :speaker="speaker"
        :color="color"
        :parameter="parameter"
        @afterDownload="afterDownload"
        @pdfDownload="pdfDownload"
        :logIndex="logIndex"
        :lastIndex="lastIndex"
        :isBot="isBot"
        :isDemo="isDemo"
        :renkeiID="renkeiID"
        :roboArguments="roboArguments"
        v-if="!isPdfDownload(message)"
      />      <!-- status -->
      <div
        class="status-box"
        :class="{ 'my-status-box': speaker === 'my', 'other-status-box': speaker === 'other' }"
      >
        <p>
          {{ messageTime }}
          <template
            v-if="
              (readTime > time && speaker === 'my') || (targetModel === 'bot' && speaker === 'my')
            "
          >
            <br />既読
          </template>
          <template v-else-if="speaker === 'my'"> <br />未読 </template>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
import createUUID from '@/functions/createUUID'
import moment from 'moment'

// メッセージパーツ
import MessageParts from '@/components/BalloonParts/MessageParts'
import SelectParts from '@/components/BalloonParts/SelectParts'
import CVParts from '@/components/BalloonParts/CVParts'
import InputParts from '@/components/BalloonParts/InputParts'
import ImageParts from '@/components/BalloonParts/ImageParts'
import UploadParts from '@/components/BalloonParts/UploadParts'
import UploadedParts from '@/components/BalloonParts/UploadedParts'
import CalendarParts from '@/components/BalloonParts/CalendarParts'
import ResumeParts from '@/components/BalloonParts/ResumeParts'
import CheckBoxParts from '@/components/BalloonParts/CheckBoxParts'
import MovieParts from '@/components/BalloonParts/MovieParts'
import PullDownParts from '@/components/BalloonParts/PullDownParts'
import CarouselParts from '@/components/BalloonParts/CarouselParts'
import DownloadParts from '@/components/BalloonParts/DownloadParts'
import OutputParts from '@/components/BalloonParts/OutputParts'
import SearchParts from '@/components/BalloonParts/SearchParts'
import PdfDownloadParts from '@/components/BalloonParts/PdfDownloadParts'
import ResumeDownloadParts from '@/components/BalloonParts/ResumeDownloadParts'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import alterReplace from '@/functions/alterStrReplace'
import _ from 'lodash'

// 外部関数
import {
  iconCreate,
  messageCreate,
  buttonCreate,
  urlCreate,
  imageCreate,
  colorCreate,
  formMessageCreate,
  downloadCreate,
  outputCreate,
  isMessage,
  isButton,
  isCVForm,
  isCalendar,
  isFileUpload,
  isFiles,
  isImage,
  isInput,
  isResume,
  isCheckBox,
  isMovie,
  isPullDown,
  isCarousel,
  isFileDownload,
  isOutput,
  isSearch,
  isPdfDownload,
  isResumePdf,
  autoColor,
  shadowStyle,
  convertMesasge,
  replaceInputWord,
  replaceWord,
  replaceCantReplaceWord,
  messageEscape
} from '@/functions/balloonFunc'

export default {
  name: 'Balloon',
  components: {
    MessageParts,
    SelectParts,
    CVParts,
    InputParts,
    ImageParts,
    UploadParts,
    UploadedParts,
    CalendarParts,
    ResumeParts,
    CheckBoxParts,
    MovieParts,
    PullDownParts,
    CarouselParts,
    DownloadParts,
    OutputParts,
    SearchParts,
    PdfDownloadParts,
    ResumeDownloadParts,
    Tooltip,
  },
  computed: {
    messageTime: function () {
      return (
        this.time.getMonth() +
        1 +
        '/' +
        this.time.getDate() +
        ' ' +
        this.time.getHours() +
        ':' +
        ('00' + this.time.getMinutes()).slice(-2)
      )
    },
    getBeforeNode() {
      if (this.scenarioData && this.scenarioData.beforenode) {
        return this.scenarioData.beforenode
      }
    },
    ...mapState('directtalk', [
      'chatLogs',
      'color',
      'data',
      'chatData',
      'seeker',
      'widgetData',
      'own',
      'targetID',
      'target',
      'targetIcon',
      'targetModel',
      'resume',
      'pdfFile',
      'chatTalkHistory',
      'roboArguments'
    ]),
    ...mapState('chatbot', [
      'scenarioIndex',
      'isSwitch',
      'scenario',
      'minipk',
      'scenarioHistoryAny',
    ]),
    ...mapState('calendar', [
      'recommendDate',
      'isErrorRecommendSchedule',
      'preserveSuggestedSchedulesList',
    ]),
  },
  data() {
    return {
      isTyping: '',
      skInfo: {
        skName: '',
        skNameSei: '',
        skNameMei: '',
        skEmail: '',
        skTel: '',
        skTel1: '',
        skTel2: '',
        skTel3: '',
        skMsg: '',
        skNamePhonetic: '',
        skNamePhoneticSei: '',
        skNamePhoneticMei: '',
        skAddress: '',
        skPrefectures: '',
        skBirth: null,
        skSex: 0,
      },
      isPressed: false,
      isInputAfter: false,
      pdfgetImage: false,
      sexTypes: ['', '男性', '女性', '選択しない'],
      preventClick: false,
      displayPrevBtnFlg: false,
      sendedFlg: false,
      renkeiID: null,
      isSubmitUrl: false,
    }
  },
  props: {
    isDemo: {
      type: Boolean,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    speaker: {
      type: String,
      required: true,
      validator: (value) => {
        return ['my', 'other'].includes(value)
      },
    },
    icon: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    time: {
      type: Date,
      required: false,
    },
    readTime: {
      type: Date,
      required: false,
    },
    isBot: {
      type: Boolean,
      required: false,
    },
    email: {
      type: String,
      required: false,
    },
    isManager: {
      type: String,
      required: false,
    },
    logIndex: {
      type: Number,
      required: false,
    },
    lastIndex: {
      type: Number,
      required: false,
    },
    files: {
      type: String,
      required: false,
    },
    filename: {
      type: String,
      required: false,
    },
    parameter: {
      required: false,
    },
    status: {
      type: Number,
      required: false,
    },
    // デモ用
    companyID: {
      type: String,
      required: false,
    },
    scnName: {
      type: String,
      required: false,
    },
    companyData: {
      required: false,
    },
    scenarioData: {
      required: false,
    },
    isAuth: {
      type: Boolean,
      required: false,
    },
    isDemoEditScenario: {
      type: Boolean,
      required: false,
    },
    isPast: {
      type: Boolean,
      required: false,
    },
    roboPartsSetOutsideScenario: {
      type: String,
      required: false,
    },
    roboPartsSetNextNode: {
      type: String,
      required: false,
    },
    isConfirm: {
      type: Boolean,
      required: false,
    },
    parentComponent: {
      type: String,
      required: false,
    }
  },
  mounted() {
    this.displayPrevBtn()
  },
  methods: {
    initScenario() {
      if (!this.isDemo) {
        this.submit('最初へ戻る', false, 0)
        // ローディングと被ってしまうので少し待つ
        setTimeout(() => {
          // botへの返信履歴を保持
          this.$store.dispatch('chatbot/getScenarioOne', {
            companyid: this.data.ckey,
            scenarioName: this.scenario.name,
            node: 'INITIALIZE',
            rate: this.color.thinking_rate,
            minipk: this.minipk,
          })
          this.$emit(
            'setLocalStorage',
            JSON.stringify({
              node: 'INITIALIZE',
              date: Date().toString(),
              isPartsSet: false,
              partsSetOutsideNextNode: ''
            })
          )
        }, 1500)
      } else {
        this.$emit('restart')
      }
    },
    iconCreate(icon, isBot, isManager) {
      return iconCreate(icon, isBot, isManager)
    },
    messageEscape(m) {
      return messageEscape(m, this.roboArguments)
    },
    messageCreate(m) {
      return messageCreate(m)
    },
    buttonCreate(m) {
      return buttonCreate(m)
    },
    urlCreate(m) {
      return urlCreate(m, this.roboArguments)
    },
    imageCreate(m) {
      return imageCreate(m)
    },
    colorCreate(m) {
      return colorCreate(m)
    },
    formMessageCreate(m) {
      return formMessageCreate(m)
    },
    isMessage(m) {
      return isMessage(m)
    },
    isButton(m) {
      return isButton(m)
    },
    isCVForm(m) {
      return isCVForm(m)
    },
    isCalendar(m) {
      return isCalendar(m)
    },
    isFileUpload(m) {
      return isFileUpload(m)
    },
    isImage(m) {
      return isImage(m)
    },
    isInput(m) {
      return isInput(m)
    },
    isResume(m) {
      return isResume(m)
    },
    isCheckBox(m) {
      return isCheckBox(m)
    },
    isFiles(m) {
      return isFiles(m)
    },
    isMovie(m) {
      return isMovie(m)
    },
    isPullDown(m) {
      return isPullDown(m)
    },
    isCarousel(m) {
      return isCarousel(m)
    },
    isFileDownload(m) {
      return isFileDownload(m)
    },
    isOutput(m) {
      return isOutput(m)
    },
    isSearch(m) {
      return isSearch(m)
    },
    isPdfDownload(m) {
      return isPdfDownload(m)
    },
    isResumePdf(m) {
      return isResumePdf(m)
    },
    alterReplace(m, d) {
      return alterReplace(m, d)
    },
    autoColor(c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle(t) {
      return shadowStyle(t)
    },
    /* XSSを防ぐためにタグが来たらerrorで返す */
    convertMesasge(m, c) {
      let color = hex2rgb(c)
      return convertMesasge(m, color, this.roboArguments)
    },
    pushButton(m, isBot, btnIndex) {
      var point = 0
      let bkPoint = this.scenario.select[btnIndex].point
        ? Number(this.scenario.select[btnIndex].point)
        : 0
      point = Number(localStorage.getItem('SCR')) + Number(this.scenario.select[btnIndex].point)
      localStorage.setItem('SCR', point)
      localStorage.setItem('BK_SCR', bkPoint)
      if (m.indexOf('[url]') > 0 && m.indexOf('[/url]') > 0) {
        this.submitUrl(this.buttonCreate(m), isBot, btnIndex)
        var win = window.open(this.urlCreate(m), 'newtab')
      } else {
        this.submit(this.buttonCreate(m), isBot, btnIndex)
      }
    },
    pushButtonCard(m, isBot, btnIndex) {
      this.submit(this.buttonCreate(m), isBot, btnIndex)
    },
    pushSelect(m, isBot, btnIndex) {
      if(this.parameter.bk_default_search_word != undefined && this.parameter.bk_default_search_word.length > 0) {
        this.clearDefaultMessage(this.parameter.bk_default_search_word,this.parameter.is_clear)
      }
      this.submit(this.buttonCreate(m), isBot, btnIndex)
    },
    inputSubmit(m, isBot, btnIndex) {
      var data = {}
      if (this.scenario.parameter['colomn_name'] && !this.isDemo) {
        switch (this.scenario.parameter['colomn_name']) {
          case '名前':
            data['name'] = m
            localStorage.setItem('NM_' + this.seeker.id, data['name'])
            localStorage.setItem('DEFAULT_NM_' + this.seeker.id, data['name'])
            break
          case 'Email':
            data['email'] = m
            localStorage.setItem('EM_' + this.seeker.id, data['email'])
            localStorage.setItem('DEFAULT_EM_' + this.seeker.id, data['email'])
            break
          case 'TEL':
            data['tel'] = m
            localStorage.setItem('TL_' + this.seeker.id, data['tel'])
            localStorage.setItem('DEFAULT_TL_' + this.seeker.id, data['tel'])
            break
          case '住所':
            data['address'] = m
            localStorage.setItem('AD_' + this.seeker.id, data['address'])
            localStorage.setItem('DEFAULT_AD_' + this.seeker.id, data['address'])
            break
          case '名前（ふりがな）':
            data['furigana'] = m
            localStorage.setItem('FR_' + this.seeker.id, data['furigana'])
            localStorage.setItem('DEFAULT_FR_' + this.seeker.id, data['furigana'])
            break
          case '生年月日':
            let age = this.getAge(m) //年齢を計算
            data['yyyymmdd'] = m
            localStorage.setItem('BD_' + this.seeker.id, data['yyyymmdd'])
            localStorage.setItem('YE_' + this.seeker.id, age)
            break
          case '資格':
            data['shikaku'] = m
            localStorage.setItem('SH_' + this.seeker.id, data['shikaku'])
            break
          case '学歴・職歴':
            data['career'] = m
            localStorage.setItem('GK_' + this.seeker.id, data['career'])
            break
          case '備考':
            data['bikou'] = m
            localStorage.setItem('BK_' + this.seeker.id, data['bikou'])
            break
          case '面接予定日':
            data['mensetsu'] = m
            localStorage.setItem('MY_' + this.seeker.id, data['mensetsu'])
            break
          case 'カスタム':
            data['custom'] = m
            localStorage.setItem(
              'CS_' + this.scenario.parameter['custom'] + '_' + this.seeker.id,
              data['custom']
            )
            break
        }
      } else if (this.scenario.parameter['colomn_name'] && this.isDemo) {
        switch (this.scenario.parameter['colomn_name']) {
          case '名前':
            data['name'] = m
            localStorage.setItem('NM_demo', data['name'])
            localStorage.setItem('DEMO_DEFAULT_NM', data['name'])
            break
          case 'Email':
            data['email'] = m
            localStorage.setItem('EM_demo', data['email'])
            localStorage.setItem('DEMO_DEFAULT_EM', data['email'])
            break
          case 'TEL':
            data['tel'] = m
            localStorage.setItem('TL_demo', data['tel'])
            localStorage.setItem('DEMO_DEFAULT_TL', data['tel'])
            break
          case '住所':
            data['address'] = m
            localStorage.setItem('AD_demo', data['address'])
            localStorage.setItem('DEMO_DEFAULT_AD', data['address'])
            break
          case '名前（ふりがな）':
            data['furigana'] = m
            localStorage.setItem('FR_demo', data['furigana'])
            localStorage.setItem('DEMO_DEFAULT_FR', data['furigana'])
            break
          case '生年月日':
            let age = this.getAge(m) //年齢を計算
            data['yyyymmdd'] = m
            localStorage.setItem('BD_demo', data['yyyymmdd'])
            localStorage.setItem('YE_demo', age)
            break
          case '資格':
            data['shikaku'] = m
            localStorage.setItem('SH_demo', data['shikaku'])
            break
          case '学歴・職歴':
            data['career'] = m
            localStorage.setItem('GK_demo', data['career'])
            break
          case '備考':
            data['bikou'] = m
            localStorage.setItem('BK_demo', data['bikou'])
            break
          case '面接予定日':
            data['mensetsu'] = m
            localStorage.setItem('MY_demo', data['mensetsu'])
            break
          case 'カスタム':
            data['custom'] = m
            localStorage.setItem(
              'CS_' + this.scenario.parameter['custom'] + '_' + 'demo',
              data['custom']
            )
            break
        }
      }
      if (this.scenario.parameter['apply_flg'] && !this.isDemo) {
        var sendData = {
          email: this.scenario.parameter['colomn_name'] == 'Email' ? m : '',
          company_id: this.data.ckey,
          sessionid: this.seeker.id,
          apply_url: this.data.url,
          is_contents: false,
        }
        this.$store.dispatch('auth/sendSubscribeNoData', sendData)
          .then(() => {
            // sendSubscribeNoDataの処理完了を待つ
            // 待つだけで処理なし
            // Websocketの処理でRoomをSELECTして、APIの処理でRoomをUPDATEしている
            // 後続の処理でWebsocketをsendしてRoomをSELECTしてロックしている間にAPI側でUPDATEをしようとしてデッドロックが発生する
            // デッドロックは同じセッション内でWebsocketの各種send処理と、APIでのSeekerやRoomの更新処理などが被ると発生する
            // 同じSeekerやRoomのレコードを参照したり更新しようとして起こるので、別のユーザーと同時接続で処理が被った場合はDjango側の処理でデッドロックは起きない
            // 他のWebsocketのsend処理でも被ることがあるので、API側にもトランザクションを分ける対策を実施
            // この処理の待ち方が正しいとは限らないので、promiseを使うなどスマートな方法に変えられればば変える
          })
      }
      this.submit(this.messageEscape(m), isBot, btnIndex)
    },
    getAge(yyyymmdd) {
      if (yyyymmdd === '未入力') {
        return ''
      }
      let birthDate = new Date(yyyymmdd)
      let nowDate = new Date()
      let birthNumber = birthDate.getFullYear() * 10000 + (birthDate.getMonth() + 1 ) * 100 + birthDate.getDate();
      let nowNumber = nowDate.getFullYear() * 10000 + (nowDate.getMonth() + 1 ) * 100 + nowDate.getDate();
      return Math.floor( (nowNumber - birthNumber) / 10000 );
    },
    checkboxSubmit(checkboxItems, isBot, btnIndex) {
      var message_array = []
      for (var k in checkboxItems) {
        if (checkboxItems[k] === true) {
          message_array.push('・' + k)
        }
      }
      var message = message_array.join('\n')
      this.submit(this.messageEscape(message), isBot, btnIndex)
    },
    returnCalendar() {
      this.$store.dispatch('calendar/resetSuggestedSchedules', this.targetID)
      this.$store.dispatch('calendar/initRecommendSchedule')
    },
    nextDay(start) {
      let param = _.cloneDeep(this.scenario.parameter)
      param.count = 5  // 明示的に5を設定
      let divide = 30
      if (param.divide !== undefined) {
        if (divide === 0) {
          divide = 60
        } else {
          divide = 30
        }
      }
      if (start) {
        //カレンダーから日付を選択
        this.$store.dispatch('calendar/preserveSuggestedSchedules', {
          suggestedSchedules: start,
          targetID: this.targetID,
        })
        let schedule_start = null
        if (start <= new Date()) {
          //当日を選択
          let now = new Date().getHours() + 3 + new Date().getMinutes() / 100
          if (now < param.work_time_start) {
            schedule_start = new Date()
            schedule_start.setSeconds(0)
            schedule_start.setHours(param.work_time_start)
            schedule_start.setMinutes(param.work_time_start * 100 - schedule_start.getHours() * 100)
          } else {
            schedule_start = new Date()
            schedule_start.setSeconds(0)
            schedule_start.setHours(schedule_start.getHours() + 3)
          }
        } else {
          //翌日以降
          schedule_start = new Date(start)
          schedule_start.setSeconds(0)
          schedule_start.setHours(param.work_time_start)
          schedule_start.setMinutes(param.work_time_start * 100 - schedule_start.getHours() * 100)
        }
        param.after = schedule_start.toLocaleString('ja-JP')
      } else {
        //「次の候補日時へ」
        this.$store.dispatch('calendar/preserveSuggestedSchedules', {
          suggestedSchedules: this.recommendDate,
          targetID: this.targetID,
        })
        param.after = new Date(
          moment(this.recommendDate[this.recommendDate.length-1].start).add('minutes', divide)
        ).toLocaleString('ja-JP')
      }
      if (this.preventClick === false) {
        this.$store
          .dispatch('calendar/getRecommendSchedule', param)
          .then((this.preventClick = true))
      }
    },
    prevDay() {
      let param = _.cloneDeep(this.scenario.parameter)
      param.count = 5  // nextDay()と同様に明示的に設定
      if (this.preserveSuggestedSchedulesList.length === 2) {
        let schedule_start = null
        if (this.preserveSuggestedSchedulesList[0].getDate() <= new Date().getDate()) {
          //当日
          let now = new Date().getHours() + 3 + new Date().getMinutes() / 100
          if (now < param.work_time_start) {
            schedule_start = new Date()
            schedule_start.setSeconds(0)
            schedule_start.setHours(param.work_time_start)
            schedule_start.setMinutes(param.work_time_start * 100 - schedule_start.getHours() * 100)
          } else {
            schedule_start = new Date()
            schedule_start.setSeconds(0)
            schedule_start.setHours(schedule_start.getHours() + 3)
          }
        } else {
          //翌日以降
          schedule_start = new Date(this.preserveSuggestedSchedulesList[0])
          schedule_start.setSeconds(0)
          schedule_start.setHours(param.work_time_start)
          schedule_start.setMinutes(param.work_time_start * 100 - schedule_start.getHours() * 100)
        }
        param.after = schedule_start.toLocaleString('ja-JP')
        this.$store.dispatch('calendar/restoreSuggestedSchedules', this.targetID)
      } else if (this.preserveSuggestedSchedulesList.length > 2) {
        const beforeTwoSuggestedSchedule = this.preserveSuggestedSchedulesList[
          this.preserveSuggestedSchedulesList.length - 2
        ]
        let divide = 30
        if (param.divide !== undefined) {
          if (divide === 0) {
            divide = 60
          } else {
            divide = 30
          }
        }
        param.after = new Date(
          moment(beforeTwoSuggestedSchedule[2].start).add('minutes', divide)
        ).toLocaleString('ja-JP')
        this.$store.dispatch('calendar/restoreSuggestedSchedules', this.targetID)
      } else if (this.preserveSuggestedSchedulesList.length === 1) {
        return
      }
      if (this.preventClick === false) {
        this.$store
          .dispatch('calendar/getRecommendSchedule', param)
          .then((this.preventClick = true))
      }
    },
    createInterviewHistory(start, end, message) {
      if (!this.isDemo) {
        // 日程調整履歴登録
        const interviewHistory = {
          seeker: this.seeker.pk,
          interview_start: start,
          interview_end: end,
          interview_comment: message,
        }
        this.$store.dispatch('directtalk/createInterviewHistory', interviewHistory)
      }
    },
    makeCalendar(m, btnIndex) {
      console.log('=== makeCalendar デバッグ開始 ===')
      console.log('選択時間:', m)
      console.log('btnIndex:', btnIndex)
      console.log('scenario.parameter:', this.scenario.parameter)
      console.log('リマインド設定:', {
        reminder_flg: this.scenario.parameter.reminder_flg,
        is_remind: this.scenario.parameter.is_remind,
        remind_time: this.scenario.parameter.remind_time,
        remind_mail: this.scenario.parameter.remind_mail
      })
      
      if (!this.isDemo) {
        try {
          var u_hash = []
          u_hash = this.scenario.parameter.user_hash
          u_hash.push(this.recommendDate[btnIndex - 1].uuid)
          var u_hash_share = this.scenario.parameter.user_hash_share
          const id = createUUID()
          var location = ''
          var start = new Date(this.recommendDate[btnIndex - 1].start).toISOString()// UTC
          var end = null
          if (this.scenario.parameter.mtg_time_hour === undefined) {
            this.scenario.parameter.mtg_time_hour = Math.floor(this.scenario.parameter.mtg_time)
          }
          if (this.scenario.parameter.mtg_time_minute === undefined) {
            this.scenario.parameter.mtg_time_minute = parseInt(
              (this.scenario.parameter.mtg_time - Math.floor(this.scenario.parameter.mtg_time)) * 60
            )
          }
          end = new Date(this.recommendDate[btnIndex - 1].end).toISOString()// UTC
          localStorage.setItem('SC_' + this.seeker.id, m)
          var isAllDay = false
          var category = 'time'
          var state = ''
          var isVisible = true
          var isPrivate = 'public'
          var isReadOnly = false
          var color = '#000'
          var bgColor = '#59C8C9'
          var borderColor = '#59C8C9'
          var dragBgColor = '#59C8C9'
          let lsApplicant = localStorage.getItem('NM_' + this.seeker.id)
          let lsEmail = localStorage.getItem('EM_' + this.seeker.id)
          let lsTel = localStorage.getItem('TL_' + this.seeker.id)
          let lsAddress = localStorage.getItem('AD_' + this.seeker.id)
          let lsFurigana = localStorage.getItem('FR_' + this.seeker.id)
          let lsYyyymmdd = localStorage.getItem('BD_' + this.seeker.id)
          let lsYears = localStorage.getItem('YE_' + this.seeker.id)
          let lsShikaku = localStorage.getItem('SH_' + this.seeker.id)
          let lsCareer = localStorage.getItem('GK_' + this.seeker.id)
          let lsBikou = localStorage.getItem('BK_' + this.seeker.id)
          let lsPoint = localStorage.getItem('SCR')
          var u_h = []
          if (this.recommendDate[btnIndex - 1].uuid.split(',').length > 1)
            u_h = this.recommendDate[btnIndex - 1].uuid.split(',')
          else u_h.push(this.recommendDate[btnIndex - 1].uuid)
          this.scenario.parameter.title = replaceInputWord(
            this.scenario.parameter.title,
            lsApplicant,
            lsEmail,
            lsTel,
            lsAddress,
            lsFurigana,
            lsYyyymmdd,
            lsYears,
            lsShikaku,
            lsCareer,
            lsBikou,
            m,
            lsPoint,
            this.roboArguments
          )
          if (this.scenario.parameter.memo) {
            this.scenario.parameter.memo = replaceInputWord(
              this.scenario.parameter.memo,
              lsApplicant,
              lsEmail,
              lsTel,
              lsAddress,
              lsFurigana,
              lsYyyymmdd,
              lsYears,
              lsShikaku,
              lsCareer,
              lsBikou,
              m,
              lsPoint,
              this.roboArguments
            )
          }
          const chatTalkHistoryReverse = this.$_.cloneDeep(this.chatTalkHistory).slice().reverse()
          for (let c of chatTalkHistoryReverse) {
            if (c.quoteWords != undefined && c.speaker == 'my') {
              this.scenario.parameter.title = replaceWord(this.scenario.parameter.title, c, this.roboArguments)
              if (this.scenario.parameter.memo) {
                this.scenario.parameter.memo = replaceWord(this.scenario.parameter.memo, c, this.roboArguments)
              }
            }
          }
          // 置換しきれなかった代替文字列を削除
          this.scenario.parameter.title = replaceCantReplaceWord(this.scenario.parameter.title)
          if (this.scenario.parameter.memo) {
            this.scenario.parameter.memo = replaceCantReplaceWord(this.scenario.parameter.memo)
          }
          // メモに動画面接URLを追加
          let videoLink = ''
          if (this.scenario.parameter.video_interview_memo) {
            videoLink =
              '\n\n------------------------------------------------------------\n' +
              '動画面接リンク\n' +
              this.scenario.parameter.video_interview_link
            if (this.scenario.parameter.memo) {
              this.scenario.parameter.memo += videoLink
            } else {
              this.scenario.parameter.memo = videoLink
            }
            localStorage.setItem(
              'VU_' + this.seeker.id,
              this.scenario.parameter.video_interview_link
            )
          }
          // 非公開フラグある場合は反映
          let isPrivate = false
          if (this.scenario.parameter.is_private) {
            isPrivate = this.scenario.parameter.is_private
          }
          var createdSchedule = {
            id: id,
            scheduleId: id,
            sessionid: this.seeker.id,
            user_hash: u_h,
            user_hash_list: u_hash,
            user_hash_share: u_hash_share,
            company_hash: this.scenario.parameter.company_hash,
            title: this.scenario.parameter.title,
            location: location,
            start: start,
            end: end,
            memo: this.scenario.parameter.memo ? this.scenario.parameter.memo : '',
            isAllDay: isAllDay,
            category: category,
            state: state,
            isVisible: isVisible,
            isPrivate: isPrivate,
            isReadOnly: isReadOnly,
            color: color,
            bgColor: bgColor,
            borderColor: borderColor,
            dragBgColor: dragBgColor,
            is_AND: this.scenario.parameter.is_AND,
            re_message: m,
            is_private: isPrivate,
            scenario_param: this.scenario.parameter,
          }
          const scenario = this.$_.cloneDeep(this.scenario)
          console.log('autoCreateSchedule呼び出し前:', createdSchedule)
          const resCreatedSchedule = this.$store
            .dispatch('calendar/autoCreateSchedule', createdSchedule)
            .then(() => {
              console.log('autoCreateSchedule成功')
              // 前へ戻るの候補を初期化
              this.$store.dispatch('calendar/resetSuggestedSchedules')
              this.afterCreateSchedule(
                start,
                end,
                m,
                lsApplicant,
                lsEmail,
                lsTel,
                lsAddress,
                lsFurigana,
                lsYyyymmdd,
                lsYears,
                lsShikaku,
                lsCareer,
                lsBikou,
                lsPoint,
                scenario,
                chatTalkHistoryReverse
              )
              return [true]
            })
            .catch((e) => {
              console.error('autoCreateScheduleエラー:', e)
              console.error('エラー詳細:', (e.response && e.response.data) || e.message)
              // 再度日程を送信してもらう
              return [false, (e.response && e.response.data && e.response.data.message) || e.message || 'Unknown Error']
            })
          return resCreatedSchedule
        } catch (e) {
          let errorMessage = {
            message: e.message ? e.message : "",
            id: this.seeker.id,
            pk: this.seeker.pk,
            company_hash: this.scenario.parameter.company_hash,
            title: this.scenario.parameter.title,
            memo: this.scenario.parameter.memo ? this.scenario.parameter.memo : '',
            event: m,
          }
          this.$store.dispatch('master/notifyTool', errorMessage)
        }
        // Emailから日程調整の場合
        if (this.$route.query.id) {
          var jstz = require('jstimezonedetect')
          var uhList = []
          // Server参照
          if (this.scenario.parameter.is_AND) {
            uhList = u_hash
            for (let uh1 of u_h) {
              var pushFlg = false
              for (let uh2 of u_hash) {
                if (uh1 === uh2) {
                  pushFlg = true
                }
              }
              if (pushFlg) {
                uhList.push(uh1)
              }
            }
          } else {
            uhList = u_h
          }
          let createData = {
            action_history: {
              seeker: this.$route.query.id,
              action: null,
              recruit_status: 2,
              action_status: 1,
              finished_status: 0,
              is_finished: false,
              interview_date: start,
              interview_time: this.scenario.parameter.mtg_time,
              interview_date_tz: jstz.determine().name(),
              interviewer: uhList,
            },
          }
          this.$store.dispatch('directtalk/createFromEmailActionHistory', createData)
        }
      } else {
        localStorage.setItem('SC_demo', m)
        const videoLink = 'VL_demo_link'
        localStorage.setItem('VL_demo', videoLink)
        return [true]
      }
    },
    reloadCalendar() {
      // 同じ時間帯の候補を再取得
      this.$store.dispatch('calendar/resetSuggestedSchedules')
      let param = _.cloneDeep(this.scenario.parameter)
      param.count = 5  // nextDay()と同様に明示的に設定
      param.after = new Date(
        moment(this.recommendDate[0].start)
      ).toLocaleString('ja-JP')
      if (this.preventClick === false) {
        this.$store
          .dispatch('calendar/getRecommendSchedule', param)
          .then((this.preventClick = true))
      }
    },
    afterCreateSchedule(
      start,
      end,
      m,
      lsApplicant,
      lsEmail,
      lsTel,
      lsAddress,
      lsFurigana,
      lsYyyymmdd,
      lsYears,
      lsShikaku,
      lsCareer,
      lsBikou,
      lsPoint,
      scenario,
      chatTalkHistoryReverse
    ) {
      this.createInterviewHistory(start, end, null)
      // リマインドメール用
      if (scenario.parameter.reminder_flg) {
        let param = scenario.parameter
        param.date = m
        param.reminder_start = start
        var jstz = require('jstimezonedetect')
        param.reminder_tz = jstz.determine().name()
        for (let c of chatTalkHistoryReverse) {
          if (c.quoteWords && c.speaker == 'my') {
            param.title = replaceWord(param.title, c, this.roboArguments)
            if (param.memo) {
              param.memo = replaceWord(param.memo, c, this.roboArguments)
            }
            param.reminder_to = replaceWord(param.reminder_to, c, this.roboArguments)
            if (param.reminder_cc) {
              param.reminder_cc = replaceWord(param.reminder_cc, c, this.roboArguments)
            }
            param.reminder_title = replaceWord(param.reminder_title, c, this.roboArguments)
            param.reminder_content = replaceWord(param.reminder_content, c, this.roboArguments)
          }
        }
        // シナリオ内に記載された代替文字列を置換
        param.reminder_content = replaceInputWord(
          param.reminder_content,
          lsApplicant,
          lsEmail,
          lsTel,
          lsAddress,
          lsFurigana,
          lsYyyymmdd,
          lsYears,
          lsShikaku,
          lsCareer,
          lsBikou,
          param.date,
          lsPoint,
          this.roboArguments
        )
        param.reminder_title = replaceInputWord(
          param.reminder_title,
          lsApplicant,
          lsEmail,
          lsTel,
          lsAddress,
          lsFurigana,
          lsYyyymmdd,
          lsYears,
          lsShikaku,
          lsCareer,
          lsBikou,
          param.date,
          lsPoint,
          this.roboArguments
        )
        param.reminder_to = replaceInputWord(
          param.reminder_to,
          lsApplicant,
          lsEmail,
          lsTel,
          lsAddress,
          lsFurigana,
          lsYyyymmdd,
          lsYears,
          lsShikaku,
          lsCareer,
          lsBikou,
          param.date,
          lsPoint,
          this.roboArguments
        )
        if (param.reminder_cc) {
          param.reminder_cc = replaceInputWord(
            param.reminder_cc,
            lsApplicant,
            lsEmail,
            lsTel,
            lsAddress,
            lsFurigana,
            lsYyyymmdd,
            lsYears,
            lsShikaku,
            lsCareer,
            lsBikou,
            param.date,
            lsPoint,
            this.roboArguments
          )
        }
        // 置換しきれなかった代替文字列を削除
        param.reminder_content = replaceCantReplaceWord(param.reminder_content)
        param.reminder_title = replaceCantReplaceWord(param.reminder_title)
        if (param.memo) {
          param.memo = replaceCantReplaceWord(param.memo)
        }
        param.reminder_to = replaceCantReplaceWord(param.reminder_to)
        if (param.reminder_cc) {
          param.reminder_cc = replaceCantReplaceWord(param.reminder_cc)
        }
        let videoLink = ''
        if (scenario.parameter.video_interview_memo && scenario.parameter.video_interview_mail) {
          videoLink =
            '\n\n------------------------------------------------------------\n' +
            '動画面接リンク\n' +
            scenario.parameter.video_interview_link
          if (param.memo) {
            param.memo += videoLink
          } else {
            param.memo = videoLink
          }
        }
        // company_hashを追加
        const company_hash = this.$store.state.auth && 
                            this.$store.state.auth.user && 
                            this.$store.state.auth.user.company && 
                            this.$store.state.auth.user.company.company_hash;
        
        // company_hashが存在しない場合は、scenario.parameterから取得
        const finalCompanyHash = company_hash || scenario.parameter.company_hash;
        
        const reminderParams = {
          ...param,
          company_hash: finalCompanyHash
        }
        console.log('リマインダーメール送信パラメータ:', reminderParams);
        this.$store.dispatch('chatbot/sendReminderEmail', { id: this.seeker.id, param: reminderParams })
      }
      // リマインドSMS用
      if (scenario.parameter.reminder_flg_sms) {
        let param = scenario.parameter
        param.date = m
        for (let c of chatTalkHistoryReverse) {
          if (c.quoteWords && c.speaker == 'my') {
            param.reminder_to_sms = replaceWord(param.reminder_to_sms, c, this.roboArguments)
            param.reminder_content_sms = replaceWord(param.reminder_content_sms, c, this.roboArguments)
          }
        }
        // シナリオ内に記載された代替文字列を置換
        param.reminder_content_sms = replaceInputWord(
          param.reminder_content_sms,
          lsApplicant,
          lsEmail,
          lsTel,
          lsAddress,
          lsFurigana,
          lsYyyymmdd,
          lsYears,
          lsShikaku,
          lsCareer,
          lsBikou,
          param.date,
          lsPoint,
          this.roboArguments
        )
        param.reminder_to_sms = replaceInputWord(
          param.reminder_to_sms,
          lsApplicant,
          lsEmail,
          lsTel,
          lsAddress,
          lsFurigana,
          lsYyyymmdd,
          lsYears,
          lsShikaku,
          lsCareer,
          lsBikou,
          param.date,
          lsPoint,
          this.roboArguments
        )
        // 置換しきれなかった代替文字列を削除
        param.reminder_content_sms = replaceCantReplaceWord(param.reminder_content_sms).replace(/\n+/g, '\n');
        param.reminder_to_sms = replaceCantReplaceWord(param.reminder_to_sms).replace(/\n+/g, '\n');
        let videoLink = ''
        if (param.video_interview_memo && param.video_interview_sms) {
          videoLink =
            '\n動画面接リンク\n' +
            param.video_interview_link
        }
        const scheduleByDay = moment(start).subtract('days', param.reminder_day_sms);
        if (moment().isBefore(scheduleByDay)) {
          this.$store.dispatch('chatbot/createSendScheduledMessage', {
            sessionid: this.seeker.id,
            status: 1,
            parameter: {
              "from": param.reminder_from_sms,
              "to": param.reminder_to_sms,
              "mainmessage": param.reminder_content_sms + videoLink,
              "date": param.date,
              "reminder_day": param.reminder_day_sms,
            },
            schedule: new Date(scheduleByDay),
            is_finished: false,
            error_log: null,
          })
        }
        if (param.reminder_before_flg_sms) {
          const scheduleByMinutes = moment(start).subtract('minutes', param.reminder_before_minute_sms + 3);
          if (moment().isBefore(scheduleByMinutes)) {
            this.$store.dispatch('chatbot/createSendScheduledMessage', {
              sessionid: this.seeker.id,
              status: 1,
              parameter: {
                "from": param.reminder_from_sms,
                "to": param.reminder_to_sms,
                "mainmessage": param.reminder_content_sms + videoLink,
                "date": param.date,
                "reminder_before_minute": param.reminder_before_minute_sms,
              },
              schedule: new Date(scheduleByMinutes),
              is_finished: false,
              error_log: null,
            })
          }
        }
      }
    },
    sendfile(file, num) {
      if (!this.isDemo) {
        // ファイルアップロード
        let createFiles = new FormData()
        createFiles.append('file', file, createUUID() + file.name)
        createFiles.append('name', file.name)
        createFiles.append('seeker', this.seeker.pk)
        this.$store.dispatch('directtalk/createSeekerFilesAny', createFiles)
        // ファイルエンコード用
        var r = new FileReader()
        var encodedFile = ''
        r.readAsDataURL(file)
        r.onloadend = () => {
          encodedFile = r.result.substr(r.result.indexOf(',') + 1).replace(/^.*,/, '')
          var data = {
            message: 'File送付',
            name: this.name,
            url: this.data.url,
            email: this.email,
            speaker: 'my',
            icon: this.icon,
            sendToID: '',
            minibot_pk: '',
            sendToModel: '',
            scenarioName: '',
            scenarioNode: '',
            btnIdx: 0,
            createdAt: new Date().toISOString(),
            isManager: '0',
            appname: '',
            platform: '',
            refferer: '',
            useragent: '',
            count: 0,
            status: this.scenario.status,
            parameter: this.scenario.parameter,
            files: encodedFile.replace(/^.*,/, ''),
            filename: file.name,
          }
          this.$store.dispatch('directtalk/pushChat', data)
          this.sendedFlg = true
          if (num === 1) {
            // 複数ファイル送ることがあるが、ここは1回だけ処理する
            // ローディングと被ってしまうので少し待つ
            setTimeout(() => {
              // botへの返信履歴を保持
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'reply_bot',
                url: this.data.url,
                element: 'button',
              })
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'react_scn',
                url: this.data.url,
                element: this.scenario.beforenode + ',' + 0,
              })
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'send_scn',
                url: this.data.url,
                element: this.scenario.beforenode,
              })
              let scenarioName = null
              let nextNode = null
              if (this.scenario.output_flg === true) {
                scenarioName = this.roboPartsSetOutsideScenario
                nextNode = this.roboPartsSetNextNode
              } else {
                scenarioName = this.scenario.name
                nextNode = this.scenario.select[0].next_node
              }
              this.$store.dispatch('chatbot/getScenarioOne', {
                companyid: this.data.ckey,
                scenarioName: scenarioName,
                node: nextNode,
                rate: this.color.thinking_rate,
                minipk: this.minipk,
              })
              this.$emit(
                'setLocalStorage',
                JSON.stringify({
                  node: nextNode,
                  date: Date().toString(),
                  isPartsSet: scenarioName == 'parts-set',
                  partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
                })
              )
            }, 1500)
          }
        }
      } else {
        this.submit('送付（DEMO）', this.isBot, 0)
        this.sendedFlg = true
      }
    },
    subscribe(e) {
      if (!this.isDemo) {
        // 保存用
        var data = {
          name: this.skInfo.skName,
          email: this.skInfo.skEmail,
          tel: this.skInfo.skTel,
          message: this.skInfo.skMsg,
          name_phonetic: this.skInfo.skNamePhonetic,
          sex: this.skInfo.skSex,
          birth: this.skInfo.skBirth,
          address:
            (this.skInfo.skPrefectures === 'その他' ? '' : this.skInfo.skPrefectures) +
            this.skInfo.skAddress,
          is_subscribe: true,
          subscribe_count: 1,
          subscribe_date: new Date().toISOString(),
          progress_rate: 0,
          job_offer_no: this.renkeiID,
          sessionid: this.seeker.id,
          group: this.data.ckey,
        }
        // 求人ページか企業ページか判定する
        var apply_url = ''
        var is_contents = ''
        if (
          this.data.url.indexOf(process.env.LOC_HOST + '/recruit/') > -1 ||
          this.data.url.indexOf(process.env.LOC_HOST + '/cstm/') > -1
        ) {
          var cid = this.data.url.split('/')
          apply_url = cid[cid.length - 1]
          is_contents = true
        } else {
          apply_url = this.data.url
          is_contents = false
        }
        // メール送信用
        var sendData = {
          name: this.skInfo.skName,
          email: this.skInfo.skEmail,
          tel: this.skInfo.skTel,
          other: this.skInfo.skMsg,
          company_id: this.data.ckey,
          sessionid: this.seeker.id,
          apply_url: apply_url,
          is_contents: is_contents,
          disable_email: (!Array.isArray(this.parameter) && this.parameter.disable_email ? this.parameter.disable_email : false)
        }
        // botへの返信履歴を保持
        this.$store.dispatch('directtalk/createSeekerATHistory', {
          target: this.email,
          action: 'subscribe_bot',
          url: this.data.url,
          element: 'button',
        })
        this.$store.dispatch('directtalk/updateSeekerData', data)
          .then(() => {
            // 待たずに送ってしまうと更新する前の応募者情報で送ってしまうので、updateSeekerDataを待つ
            this.$store.dispatch('auth/sendSubscribe', sendData)
              .then(() => {
                // Websocketの処理でRoomをSELECTして、APIの処理でRoomをUPDATEしている
                // 後続の処理でWebsocketをsendしてRoomをSELECTしてロックしている間にAPI側でUPDATEをしようとしてデッドロックが発生する
                // なのでsendSubscribeの処理完了を待つ
                // 待つだけで処理なし
                // デッドロックは同じセッション内でWebsocketの各種send処理と、APIでのSeekerやRoomの更新処理などが被ると発生する
                // 同じSeekerやRoomのレコードを参照したり更新しようとして起こるので、別のユーザーと同時接続で処理が被った場合はDjango側の処理でデッドロックは起きない
                // 他のWebsocketのsend処理でも被ることがあるので、API側にもトランザクションを分ける対策を実施
                // この処理の待ち方が正しいとは限らないので、promiseを使うなどスマートな方法に変えられればば変える
              })
          })
      }

      let subscribeMessage = ''
      subscribeMessage += '【応募内容】\n'
      if (this.companyData.subscribe_is_name) {
        subscribeMessage += 'お名前：' + this.skInfo.skName + '\n'
      }
      if (this.companyData.subscribe_is_name_phonetic) {
        subscribeMessage += 'フリガナ：' + this.skInfo.skNamePhonetic + '\n'
      }
      if (this.companyData.subscribe_is_sex) {
        subscribeMessage += '性別：' + this.sexTypes[this.skInfo.skSex] + '\n'
      }
      if (this.companyData.subscribe_is_email) {
        subscribeMessage += 'Email：' + this.skInfo.skEmail + '\n'
      }
      if (this.companyData.subscribe_is_tel) {
        subscribeMessage += 'TEL：' + this.skInfo.skTel + '\n'
      }
      var t = this.skInfo.skBirth
      if (this.companyData.subscribe_is_birth) {
        if (t === null) {
          subscribeMessage += '生年月日：' + '\n'
        } else {
          subscribeMessage +=
            '生年月日：' + t.getFullYear() + '/' + (t.getMonth() + 1) + '/' + t.getDate() + '\n'
        }
      }
      if (this.companyData.subscribe_is_address) {
        subscribeMessage +=
          '住所：' +
          (this.skInfo.skPrefectures === 'その他' ? '' : this.skInfo.skPrefectures) +
          this.skInfo.skAddress +
          '\n'
      }
      if (this.companyData.subscribe_is_message) {
        subscribeMessage += '備考：' + this.skInfo.skMsg + '\n'
      }
      let quoteAnswers = {}
      if (this.companyData.subscribe_is_name) {
        quoteAnswers.name = this.skInfo.skName
      }
      if (this.companyData.subscribe_is_name_phonetic) {
        quoteAnswers.furigana = this.skInfo.skNamePhonetic
      }
      if (this.companyData.subscribe_is_email) {
        quoteAnswers.email = this.skInfo.skEmail
      }
      if (this.companyData.subscribe_is_tel) {
        quoteAnswers.tel = this.skInfo.skTel
      }
      if (this.companyData.subscribe_is_address) {
        quoteAnswers.address =
          (this.skInfo.skPrefectures === 'その他' ? '' : this.skInfo.skPrefectures) +
          this.skInfo.skAddress
      }
      if (this.companyData.subscribe_is_sex) {
        quoteAnswers.gender = this.skInfo.skSex
      }
      if (this.companyData.subscribe_is_birth) {
        quoteAnswers.birth = this.skInfo.skBirth
      }
      if (this.companyData.subscribe_is_message) {
        quoteAnswers.msg = this.skInfo.skMsg
      }
      const subscribeArr = {
        subscribeMessage: subscribeMessage,
        quoteAnswers: quoteAnswers,
      }
      this.submit(subscribeArr, true, 0)
    },
    afterDownload(btnIndex) {
      let scenarioName = null
      let nextNode = null
      if (this.scenario.output_flg === true) {
        scenarioName = this.roboPartsSetOutsideScenario
        nextNode = this.roboPartsSetNextNode
      } else {
        scenarioName = this.scenario.name
        nextNode = this.scenario.select[btnIndex].next_node
      }
      if (!this.isDemo) {
        // 本番ケース
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
        this.$emit(
          'setLocalStorage',
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          })
        )
      } else {
        // DEMOケース
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.companyID,
          scenarioName: scenarioName,
          node: nextNode,
          rate: this.color.thinking_rate,
          minipk: this.minipk,
        })
      }
    },
    pdfDownload() {
      // PDFダウンロード
      let pdfMakeInfo = {}
      let scenarioName = ''
      if (this.scenario.name === 'parts-set') {
        scenarioName = this.roboPartsSetOutsideScenario
      } else {
        scenarioName = this.scenario.name
      }
      // ファイル名をロボ引用で置換
      let sendParameter = JSON.parse(JSON.stringify(this.parameter))
      // ロボ引用がある場合は置換する
      if (this.roboArguments) {
        for (const arg of this.roboArguments) {
          sendParameter.file_name = sendParameter.file_name.replace(
            new RegExp(arg.key, 'g'),
            arg.value
          )
        }
      }
      // 置換できなかったロボ引用の引用文字列を削除する
      sendParameter.file_name = sendParameter.file_name.replace(new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'), '')

      if (!this.isDemo) {
        // デモ以外
        pdfMakeInfo = {
          pdf_info: sendParameter,
          company_id: this.data.ckey,
          scenario_id: scenarioName,
          minipk: this.minipk || '',
          seeker_info: this.seeker
        }
      } else {
        // デモ
        pdfMakeInfo = {
          pdf_info: sendParameter,
          company_id: this.companyID,
          scenario_id: scenarioName,
          minipk: this.minipk || '',
          seeker_info: {
            // デモの場合メール送信したくないので、下記変えないこと
            name: 'シナリオデモ',
            email: 'demo@demo.co.jp',
          }
        }
      }
      this.$store.dispatch('chatbot/PdfDownload', pdfMakeInfo).then((d) => {
        let element = document.createElement('a')
        let blob = new Blob([d.request.response], { type: d.headers['content-type'] })
        element.href = window.URL.createObjectURL(blob)
        element.download = sendParameter.file_name + '.pdf'
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
      })
    },
    pulldownSubmit(selectItems, isBot, btnIndex) {
      this.submit(selectItems, isBot, btnIndex)
    },
    submit(m, isBot, btnIndex) {
      localStorage.removeItem('msg')
      let scenarioName = null
      let nextNode = null
      if (this.scenario.output_flg === true) {
        scenarioName = this.roboPartsSetOutsideScenario
        nextNode = this.roboPartsSetNextNode
      } else {
        scenarioName = this.scenario.name
        nextNode = this.scenario.select[btnIndex].next_node
      }
      if (!this.isDemo) {
        // 本番ケース
        // ヒストリに保存
        let scnHistory = this.scenarioHistoryAny
        scnHistory.end = new Date()
        scnHistory.is_cv = this.scenario.is_cv
        if (this.scenario.is_cv) {
          const data = {
            timing: 2,
            bot_id: scnHistory.chatbot,
            session_id: this.seeker.id,
            end: new Date()
          }
          this.$store.dispatch('directtalk/setAutoAction', data)
        }
        this.$store.dispatch('chatbot/updateScenarioHistoryAny', scnHistory)
        // ここから送付処理
        this.isPressed = true
        var w = this.data
        this.chatData.name = this.widgetData.name
        this.chatData.url = w.url
        if (m.subscribeMessage && m.quoteAnswers) {
          // 応募フォーム or 履歴書フォーム or プルダウンのとき
          localStorage.setItem('msg', m.subscribeMessage)
          this.chatData.message = m.subscribeMessage
          this.chatData.quoteAnswers = m.quoteAnswers
        } else if (this.scenario.status === 6) {
          localStorage.setItem('msg', m)
          this.chatData.message = m
        } else {
          localStorage.setItem('msg', alterReplace(m, false))
          this.chatData.message = alterReplace(m, false)
        }
        this.chatData.message = this.messageEscape(this.chatData.message)
        if (this.chatData.message !== '') {
          this.chatData.email = ''
          var today = new Date()
          this.chatData.createdAt = today.toISOString()
          this.chatData.isManager = '0'
          this.chatData.sendToID = this.targetID
          this.chatData.minibot_pk = this.minipk ? this.minipk : ''
          this.chatData.sendToModel = this.targetModel
          this.chatData.scenarioName = scenarioName
          this.chatData.scenarioNode = this.scenario.beforenode
          this.chatData.btnIdx = btnIndex
          this.chatData.status = this.scenario.status
          this.chatData.parameter = this.scenario.parameter
          this.chatData.quoteFlg = this.scenario.quote_flg
          this.chatData.pk = this.scenario.pk
          this.isInputAfter = true
          if (this.chatData.quoteFlg) {
            if (this.chatData.status == 1 || this.chatData.status == 8) {
              // 応募フォーム or 履歴書フォームのとき
              this.chatData.quoteWords = {
                name: '__' + this.chatData.pk + '.name__',
                furigana: '__' + this.chatData.pk + '.furigana__',
                email: '__' + this.chatData.pk + '.email__',
                tel: '__' + this.chatData.pk + '.tel__',
                gender: '__' + this.chatData.pk + '.gender__',
                address: '__' + this.chatData.pk + '.address__',
                birth: '__' + this.chatData.pk + '.birth__',
                message: '__' + this.chatData.pk + '.message__',
              }
            } else if (this.chatData.status == 15) {
              // プルダウンのとき
              this.chatData.quoteWords = { answer: '__' + this.chatData.pk + '__' }
              for (let i in this.chatData.parameter) {
                const num = Number(i) + 1
                this.chatData.quoteWords['pulldown' + num] =
                  '__' + this.chatData.pk + '.pulldown' + num + '__'
              }
            } else {
              this.chatData.quoteWords = {
                answer: '__' + this.chatData.pk + '__',
              }
            }
          }
          var promise = Promise.resolve()
          promise
            .then(
              this.$store.dispatch('auth/slackPost', {
                companyID: this.data.ckey,
                seekerID: this.seeker.id,
                msg: this.chatData.message,
              })
            )
            .then(
              this.$store.dispatch('auth/CWPost', {
                companyID: this.data.ckey,
                seekerID: this.seeker.id,
                msg: this.chatData.message,
              })
            )
            .then(this.$store.dispatch('directtalk/pushChat', this.chatData))
          this.chatData.message = ''
          // ローディングと被ってしまうので少し待つ
          setTimeout(() => {
            if (isBot) {
              // botへの返信履歴を保持
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'reply_bot',
                url: this.data.url,
                element: 'button',
              })
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'react_scn',
                url: this.data.url,
                element: this.scenario.beforenode + ',' + btnIndex,
              })
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'send_scn',
                url: this.data.url,
                element: this.scenario.beforenode,
              })
              this.$store.dispatch('chatbot/getScenarioOne', {
                companyid: this.data.ckey,
                scenarioName: scenarioName,
                node: nextNode,
                rate: this.color.thinking_rate,
                minipk: this.minipk,
              })
              this.$emit(
                'setLocalStorage',
                JSON.stringify({
                  node: nextNode,
                  date: Date().toString(),
                  isPartsSet: scenarioName == 'parts-set',
                  partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
                })
              )
            }
          }, 1500)
        }
      } else {
        // DEMOケース
        this.chatData.name = 'あなた'
        this.chatData.url = 'demo'
        // 応募フォーム or 履歴書フォーム or プルダウンのとき
        if (m.subscribeMessage && m.quoteAnswers) {
          localStorage.setItem('msg', m.subscribeMessage)
          this.chatData.message = m.subscribeMessage
          this.chatData.quoteAnswers = m.quoteAnswers
        } else if (this.scenario.status === 6) {
          localStorage.setItem('msg', m)
          this.chatData.message = m
        } else {
          localStorage.setItem('msg', alterReplace(m, false))
          this.chatData.message = alterReplace(m, false)
        }
        if (this.chatData.message !== '') {
          this.pushChat(this.getChatData(this.chatData, this.scenario))
          setTimeout(() => {
            if (isBot) {
              let scenarioName = null
              let nextNode = null
              if (this.scenario.output_flg === true) {
                scenarioName = this.roboPartsSetOutsideScenario
                nextNode = this.roboPartsSetNextNode
              } else {
                scenarioName = this.scenario.name
                nextNode = this.scenario.select[btnIndex].next_node
              }
              this.$store.dispatch('chatbot/getScenarioOne', {
                companyid: this.companyID,
                scenarioName: scenarioName,
                node: nextNode,
                rate: this.color.thinking_rate,
                minipk: this.minipk,
              })
            }
          }, 1500)
        }
      }
    },
    submitUrl(m, isBot, btnIndex) {
      // URLを選択している間は、別の選択肢を押せるようにするため、URLの選択肢であるかどうかの情報を渡す
      this.isSubmitUrl = true
      localStorage.removeItem('msg')
      let scenarioName = null
      if (this.scenario.output_flg === true) {
        scenarioName = this.roboPartsSetOutsideScenario
      } else {
        scenarioName = this.scenario.name
      }
      if (!this.isDemo) {
        // 本番ケース
        // ヒストリに保存
        let scnHistory = this.scenarioHistoryAny
        scnHistory.end = new Date()
        scnHistory.is_cv = this.scenario.is_cv
        // Goal設定がある場合の自動採用フローアクション設定
        if (this.scenario.is_cv) {
          const actionData = {
            timing: 2,
            bot_id: scnHistory.chatbot,
            session_id: this.seeker.id,
            end: new Date()
          }
          this.$store.dispatch('directtalk/setAutoAction', actionData)
        }
        this.$store.dispatch('chatbot/updateScenarioHistoryAny', scnHistory)
        // ここからWebSocket送付処理
        this.isPressed = true
        var w = this.data
        this.chatData.name = this.widgetData.name
        this.chatData.url = w.url
        localStorage.setItem('msg', alterReplace(m, false))
        this.chatData.message = alterReplace(m, false)
        this.chatData.message = this.messageEscape(this.chatData.message)
        if (this.chatData.message !== '') {
          this.chatData.email = ''
          var today = new Date()
          this.chatData.createdAt = today.toISOString()
          this.chatData.isManager = '0'
          this.chatData.sendToID = this.targetID
          this.chatData.minibot_pk = this.minipk ? this.minipk : ''
          this.chatData.sendToModel = this.targetModel
          this.chatData.scenarioName = scenarioName
          this.chatData.scenarioNode = this.scenario.beforenode
          this.chatData.btnIdx = btnIndex
          this.chatData.status = this.scenario.status
          this.chatData.parameter = this.scenario.parameter
          this.chatData.quoteFlg = this.scenario.quote_flg
          this.chatData.pk = this.scenario.pk
          this.isInputAfter = true
          if (this.chatData.quoteFlg) {
            this.chatData.quoteWords = {
              answer: '__' + this.chatData.pk + '__',
            }
          }
          var promise = Promise.resolve()
          promise
            .then(
              this.$store.dispatch('auth/slackPost', {
                companyID: this.data.ckey,
                seekerID: this.seeker.id,
                msg: this.chatData.message,
              })
            )
            .then(
              this.$store.dispatch('auth/CWPost', {
                companyID: this.data.ckey,
                seekerID: this.seeker.id,
                msg: this.chatData.message,
              })
            )
            .then(this.$store.dispatch('directtalk/pushChat', this.chatData))
          this.chatData.message = ''
          // ローディングと被ってしまうので少し待つ
          setTimeout(() => {
            if (isBot) {
              // botへの返信履歴を保持
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'reply_bot',
                url: this.data.url,
                element: 'button',
              })
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'react_scn',
                url: this.data.url,
                element: this.scenario.beforenode + ',' + btnIndex,
              })
              // ロボパフォーマンスを測る時に利用される履歴
              this.$store.dispatch('directtalk/createSeekerATHistory', {
                target: this.email,
                action: 'send_scn',
                url: this.data.url,
                element: this.scenario.beforenode,
              })
            }
          }, 1500)
        }
      } else {
        // DEMOケース
        this.chatData.name = 'あなた'
        this.chatData.url = 'demo'
        localStorage.setItem('msg', alterReplace(m, false))
        this.chatData.message = alterReplace(m, false)
        if (this.chatData.message !== '') {
          this.pushChat(this.getChatData(this.chatData, this.scenario))
        }
      }
    },
    getChatData(chatData, scenario) {
      return {
        beforenode: scenario.beforenode,
        message: chatData.message,
        name: 'あなた',
        url: 'demo',
        email: '',
        speaker: 'my',
        icon: '',
        isBot: false,
        createdAt: new Date().toISOString(),
        isManager: '0',
        appname: '',
        platform: '',
        refferer: '',
        useragent: '',
        count: 0,
        status: scenario.status,
        parameter: chatData.parameter,
        quoteFlg: scenario.quote_flg,
        pk: scenario.pk,
        quoteWords: chatData.quoteWords,
        quoteAnswers: chatData.quoteAnswers,
      }
    },
    pushChat(pushData) {
      this.$emit('pushChat', pushData)
    },
    sendResume(skdata, resumeData) {
      if (resumeData) {
        let sendResumeData = JSON.parse(JSON.stringify(resumeData))
        // 足りないパラメーターがあるので書き換える
        sendResumeData.parameter = JSON.parse(JSON.stringify(this.scenario.parameter))
        // ロボ引用がある場合は置換する
        if (this.roboArguments) {
          for (const arg of this.roboArguments) {
            sendResumeData.parameter.file_name = sendResumeData.parameter.file_name.replace(
              new RegExp(arg.key, 'g'),
              arg.value
            )
          }
        }
        setTimeout(() => {
          let pdfData = null
          this.$store
            .dispatch('directtalk/createResumePdf', sendResumeData)
            .then((d) => {
              if (sendResumeData.parameter.enable_download) {
                // 応募者に履歴書ダウンロードを許可する場合はメッセージを投げる
                pdfData = d.data
                const data = {
                  message: '履歴書ダウンロード',
                  name: this.name,
                  url: this.data.url,
                  email: this.email,
                  speaker: 'my',
                  icon: this.icon,
                  sendToID: '',
                  minibot_pk: '',
                  sendToModel: '',
                  scenarioName: '',
                  scenarioNode: '',
                  btnIdx: 0,
                  createdAt: new Date().toISOString(),
                  isManager: '0',
                  appname: '',
                  platform: '',
                  refferer: '',
                  useragent: '',
                  count: 0,
                  status: this.scenario.status,
                  parameter: sendResumeData.parameter,
                  files: pdfData.replace(/^.*,/, ''),
                  filename: '履歴書.pdf',
                }
                this.$store.dispatch('directtalk/pushChat', data)
              }
              let scenarioName = null
              let nextNode = null
              if (this.scenario.output_flg === true) {
                scenarioName = this.roboPartsSetOutsideScenario
                nextNode = this.roboPartsSetNextNode
              } else {
                scenarioName = this.scenario.name
                nextNode = this.scenario.select[0].next_node
              }
              this.$store.dispatch('chatbot/getScenarioOne', {
                companyid: this.data.ckey,
                scenarioName: scenarioName,
                node: nextNode,
                rate: this.color.thinking_rate,
                minipk: this.minipk,
              })
              this.$emit(
                'setLocalStorage',
                JSON.stringify({
                  node: nextNode,
                  date: Date().toString(),
                  isPartsSet: scenarioName == 'parts-set',
                  partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
                })
              )
              this.$store.dispatch('directtalk/setPdfCreating', false)
            })
            .catch((e) => {
              alert('履歴書PDF作成でエラーが発生いたしました。')
              this.$store.dispatch('directtalk/setPdfCreating', false)
            })
        }, 5000)
      } else {
        const subscribeMessage = '履歴書を送付'
        const quoteAnswers = {
          name: skdata.name,
          furigana: skdata.name_phonetic,
          gender: skdata.sex,
          birth: skdata.birth ? new Date(skdata.birth) : undefined,
          email: skdata.email,
          tel: skdata.tel,
          address: skdata.address,
          msg: '',
        }
        const subscribeArr = {
          subscribeMessage: subscribeMessage,
          quoteAnswers: quoteAnswers,
        }
        this.submit(subscribeArr, true, 0)
      }
    },
    openEditModal() {
      this.$emit('scenarioEdit', this.scenarioData.beforenode)
    },
    displayPrevBtn() {
      if (this.preserveSuggestedSchedulesList.length > 1) {
        this.displayPrevBtnFlg = true
      }
    },
    setRenkeiID(renkeiID) {
      this.renkeiID = renkeiID
    },
    updateMainMessage(value, oldValue, logIndex) {
      this.$emit('updateMainMessage', value, oldValue, logIndex)
    },
    // 引数はchatlogs用のインデックス、chatTalkHistory用のインデックス、初期値設定内容、プルダウンリストの選択要素
    clearHistoryMessage(clidx, idx, inputMessage, qa) {
      if(~inputMessage.indexOf(this.chatLogs[clidx].message)) {
        this.chatLogs[clidx].message = ''
        this.chatTalkHistory[idx].message = ''
      }
      if(this.chatTalkHistory[idx].quoteAnswers != undefined) {
        if(qa != "") {
        　//その他対応
          if(qa == 'message') {
            qa = 'msg'
          }
          if(this.chatTalkHistory[idx].quoteAnswers[qa] != undefined) {
            let clearWord = this.chatTalkHistory[idx].quoteAnswers[qa]
            if(qa == 'gender') {
              if(clearWord == '1') {
                clearWord = '男性'
              } else if(clearWord == '2') {
                clearWord = '女性'
              } else if(clearWord == '3') {
                clearWord = '選択しない'
              }
            }
            if(qa == 'birth') {
              clearWord = new Date(clearWord)
              clearWord = clearWord.getFullYear()+"/"+(clearWord.getMonth()+1)+"/"+clearWord.getDate()
            }
            if( ~inputMessage.indexOf(clearWord)) {
              let clearValue = ''
              if(qa == 'birth') {
                clearValue = 'Invalid date'
              }
              if(qa == 'gender') {
                clearValue = null
              }
              this.chatTalkHistory[idx].quoteAnswers[qa] = clearValue
            }
          }
        }
      }
    },
    clearDefaultMessage(initValue,isClear) {
      let idx = 0
      let clidx = 0
      let cthlen = this.chatTalkHistory.length
      let cllen = this.chatLogs.length
      for (let ct of this.chatTalkHistory) {
        if (ct.quoteFlg && ct.message !== '' && isClear == true) {
          if(ct.quoteWords != undefined) {
            if(~initValue.indexOf(ct.quoteWords.answer)) {
              // デモ版とURL版で履歴データを持つ量が違うための対応
              clidx = cllen - (cthlen - idx)
              this.clearHistoryMessage(clidx, idx, this.parameter.default_search_word, "")
            } else {
              // プルダウンのリストおよび応募者対応
              if(ct.quoteWords) {
                for(let qa of Object.keys(ct.quoteWords)) {
                  if(~initValue.indexOf(ct.quoteWords[qa])) {
                    clidx = cllen - (cthlen - idx)
                    this.clearHistoryMessage(clidx, idx, this.parameter.default_search_word, qa)
                  }
                }
              }
            }
          }
        }
        idx++
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-timeline {
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: space-between;
  overflow-x: visible;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}
.my-timeline {
  flex-direction: row-reverse;
}
.other-timeline {
  flex-direction: row;
}
.avatar-box {
  width: 40px;
  min-width: 40px;
  height: 96px;
  z-index: 5;
}
.avatar-box > img {
  width: 40px;
  height: 40px;
  border-radius: 30px;
  border: 1px solid #f8f8f8;
  box-shadow: 0 1px 1px #ddd;
  background: #fefefe;
  object-fit: cover;
  z-index: 5;
}
.status-box {
  font-size: 12px;
  color: #666;
}
.my-status-box {
  margin-right: 12px;
  p {
    text-align: end;
  }
}
.other-status-box {
  margin-left: 12px;
  p {
    text-align: left;
  }
}
.message-box {
  width: 100%;
}
.my-message-box {
  margin-top: 16px;
  margin-right: -20px;
  width: calc(100% - 40px);
}
.other-message-box {
  margin-top: 16px;
  margin-left: -20px;
  width: 100%;
}
.edit-btn {
  padding: 0;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-top: 8px;
  z-index: 10;
  border: solid 1.5px #a22;
  color: #a22;
}
.target-name {
  background-color:burlywood;
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Balloon.vue